<template>
  <Header></Header>
  <div><el-image class="tbtp" :src="cp_dt"></el-image></div>
  <div v-if="bz!=null" >
    <div class="title">被子區</div>
    <div class="subtitle">具有柔软高透气性，高吸湿性等特性</div>
    <el-scrollbar>
      <ul class="infinite-list" style="height: 150px; white-space: nowrap">
        <li v-for="item of bz" :key="item.index" class="infinite-list-item" @click="openBox(item.prod_sn)">
          <el-image class="dl-tp" :src="item.url"></el-image>
          <div class="dl-wz">{{ item.prod_des }}</div>
        </li>
      </ul>
    </el-scrollbar>
  </div>
  <div v-if="zt!=null" class="clearfix">
    <div class="title">枕頭專區</div>
    <div class="subtitle">健康生活，舒适睡眠，安全监测适合各类人群</div>
    <div class="zp" v-for="item of zt" :key="item.index" wx:key="index" @click="openBox(item.prod_sn)">
      <el-image :src="item.url"></el-image>
      <div class="zpdes">{{ item.prod_des }}</div>
    </div>
  </div>
  <Footer></Footer>
  <Box
  :dialogVisible="box.dialogVisible"
  :goods_id="box.goods_id"
  @close="boxClose"
  ></Box>
</template>

<script>
import Header from "@/components/Header_m";
import Footer from "@/components/Footer_m";
import Box from "@/components/Box_m";
export default {
  name: "cp_m",
  data() {
    return {
      cp_dt: "http://139.159.153.112:8200/gw_lmm/cp1_m.jpg",
      cp2: "http://139.159.153.112:8200/gw_lmm/cp2.png",
      cp3: "http://139.159.153.112:8200/gw_lmm/cp3.png",
       zt:[],
       bz:[],
         box: {
        dialogVisible: false,
        goods_id: "",
      },
      // bz: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/bz/1.png",
      //     prod_des: "天竺棉夏凉被",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/bz/2.png",
      //     prod_des: "天竺棉夏凉被",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/bz/3.png",
      //     prod_des: "天竺棉夏凉被",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/bz/4.png",
      //     prod_des: "天竺棉夏凉被",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/bz/5.png",
      //     prod_des: "天竺棉夏凉被",
      //   },
      // ],
      // zt: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/1.jpg",
      //     prod_des: "蘆薈布床褥保潔墊",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/2.jpg",
      //     prod_des: "蘆薈布枕套",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/3.jpg",
      //     prod_des: "蘆薈布太空棉枕",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/4.jpg",
      //     prod_des: "蘆薈布舒適枕",
      //   },
      // ],
    };
  },
  components: { Footer,Header,Box },
  created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
      this.queryProdZT()
    }
  },
  methods:{
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 查询推荐货品
    queryProdZT() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"B001",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.zt=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    }
  }
};
</script>

<style scoped>
.tbtp {
  height: 150px;
}
.title {
  margin-top: 25px;
  font-size: 22px;
  color: rgb(51, 51, 51);
}
.subtitle {
  font-size: 12px;
  line-height: 25px;
  color: rgb(51, 51, 51);
}

/* 單輪 */
.infinite-list {
  height: 180px;
  padding-left: 5px !important;
}
.infinite-list-item {
  display: inline-block;
  width: 200px;
  height: 150px;
  margin-right: 10px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.dl-tp {
  width: 200px;
  height: 115px;
}
.dl-wz {
  font-size: 13px;
}

/* 展示 */
.zp {
  float: left;
  width: 44vw;
  height: 50vw;
  margin-left: 2.8vw;
  margin-top: 4vw;
  border-radius: 5px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.zp .el-image {
  width: 44vw;
  height: 40vw;
}
.zpdes {
  font-size: 13px;
}
</style>